export default "__VITE_ASSET__669942c4__"